/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagePostImageCompress } from "../../funcs/imagePostImageCompress.js";
import { PostImageCompressRequest$zodSchema } from "../../models/postimagecompressop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostImageCompressRequest$zodSchema,
};

export const tool$imagePostImageCompress: ToolDefinition<typeof args> = {
  name: "image-post-image-compress",
  description: `无损压缩图片

还在为图片体积和加载速度发愁吗？体验一下我们强大的**无损压缩服务**，它能在几乎不牺牲任何肉眼可感知的画质的前提下，将图片体积压缩到极致。

## 功能概述
你只需要上传一张常见的图片（如 PNG, JPG），选择一个压缩等级，就能获得一个体积小到惊人的压缩文件。这对于需要大量展示高清图片的网站、App 或小程序来说，是优化用户体验、节省带宽和存储成本的利器。

## 使用须知
> [!TIP]
> 为了给您最好的压缩效果，我们的算法需要进行复杂计算，处理时间可能会稍长一些，请耐心等待。

> [!WARNING]
> **服务排队提醒**
> 这是一个计算密集型服务。在高并发时，您的请求可能会被排队等待处理。如果您需要将其集成到对延迟敏感的生产服务中，请注意这一点。

### 请求与响应格式
- 请求必须使用 \`multipart/form-data\` 格式上传文件。
- 成功响应将直接返回压缩后的文件二进制流 (\`image/*\`)，并附带 \`Content-Disposition\` 头，建议客户端根据此头信息保存文件。

## 参数详解
### \`level\` (压缩等级)
这是一个从 \`1\` 到 \`5\` 的整数，它决定了压缩的强度和策略，数字越小，压缩率越高。所有等级都经过精心调校，以在最大化压缩率的同时保证出色的视觉质量。
- \`1\`: **极限压缩** (推荐，体积最小，画质优异)
- \`2\`: **高效压缩**
- \`3\`: **智能均衡** (默认选项)
- \`4\`: **画质优先**
- \`5\`: **专业保真** (压缩率稍低，保留最多图像信息)

## 错误处理指南
- **400 Bad Request**: 通常因为没有上传文件，或者 \`level\` 参数不在 1-5 的范围内。
- **500 Internal Server Error**: 如果在压缩过程中服务器发生内部错误，会返回此状态码。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await imagePostImageCompress(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
